import { STOCK_PRODUCT_IMAGES } from "../data/stockProductImages.js";
import { PRESET_INTEREST_LABELS } from "../data/interestGroups.js";
import { SHOW_AMAZON_IMAGES } from "../config/amazonDataAvailability.js";

/**
 * First `rec.tags` entry that maps to a curated category stock photo, if any.
 * @param {Record<string, unknown> | null | undefined} rec
 * @returns {string | null}
 */
function stockImageUrlForRec(rec) {
  const tags = Array.isArray(rec?.tags) ? rec.tags : [];
  for (const tag of tags) {
    if (typeof tag === "string" && PRESET_INTEREST_LABELS.has(tag)) {
      const entry = STOCK_PRODUCT_IMAGES[tag];
      if (entry?.url) return entry.url;
    }
  }
  return null;
}

/**
 * Reco card image source. Every product in a preset interest bucket shares one
 * free-to-use category stock photo (see `data/stockProductImages.js`) instead of a
 * scraped Amazon product photo, so odd product-photo aspect ratios/sizes never
 * reach the card. Falls back to the rec's own captured image (Amazon or saved
 * Firestore doc) only when `SHOW_AMAZON_IMAGES` is re-enabled or the rec has no
 * catalog interest tag to key a stock photo off of.
 * @param {Record<string, unknown> | null | undefined} rec
 * @param {string} fallback
 * @returns {string}
 */
export function resolveRecoImageSrc(rec, fallback) {
  if (!rec || typeof rec !== "object") return fallback;

  const stockUrl = stockImageUrlForRec(rec);
  if (stockUrl) return stockUrl;

  if (SHOW_AMAZON_IMAGES) {
    const u =
      (typeof rec.imageUrl === "string" && rec.imageUrl.trim()) ||
      (typeof rec.imageSrc === "string" && rec.imageSrc.trim()) ||
      (typeof rec.thumbnailUrl === "string" && rec.thumbnailUrl.trim()) ||
      "";
    if (u) return u;
  }

  return fallback;
}
